(function($) {
  $(document).ready(function() {

    $("#brand-scroll-to").click(function() {
      $('html, body').animate({
        scrollTop: $("#primary").offset().top
      }, 700);
    });

  });
})(jQuery);
